import React from "react";
import { Form, Input, Select, Row, Col, Card, Switch, Alert } from "antd";
import { ThunderboltOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const ModuleDetailsFormSection = ({ entityTypeOptions }) => (
  <Card bordered={false} style={{ marginBottom: 24 }}>
    <Row gutter={24}>
      <Col xs={24} md={12}>
        <Form.Item
          label="Entity Type (Module)"
          name="entityType"
          rules={[{ required: true, message: "Please select entity type" }]}
        >
          <Select options={entityTypeOptions} placeholder="Select entity type" />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          label="Template Name"
          name="name"
          rules={[{ required: true, message: "Please enter template name" }]}
        >
          <Input placeholder="Enter template name" />
        </Form.Item>
      </Col>
      <Col xs={24}>
        <Form.Item label="Description" name="description">
          <TextArea placeholder="Template description" rows={3} />
        </Form.Item>
      </Col>
      <Col xs={24} md={12}>
        <Form.Item
          label="Auto Approve"
          name="autoApprove"
          valuePropName="checked"
        >
          <Switch checkedChildren={<ThunderboltOutlined />} />
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(prev, cur) => prev.autoApprove !== cur.autoApprove}>
          {({ getFieldValue }) =>
            getFieldValue("autoApprove") ? (
              <Alert
                type="info"
                showIcon
                message="Auto Approve enabled — no approver steps required. The rule on this template determines when it fires. Combine with a second template (autoApprove OFF) that handles the same entity type for the reject/manual path."
                style={{ marginBottom: 12 }}
              />
            ) : null
          }
        </Form.Item>
      </Col>
    </Row>
  </Card>
);

export default ModuleDetailsFormSection;
